import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactTypingEffect from 'react-typing-effect';
import Page from '../../../layout/components/Page';
import LoanCalculator from '../../Common/LoanCalculator';
import RecentTransactions from '../RecentTransactions';
import InvestmentMetrics from './InvestmentMetrics';
import NextInvestmentRepayment from './NextInvestmentRepayment';
import { RootState } from "../../../states/reducers";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "../../ErrorFallback/ErrorFallback";
import { useFetchActiveInvestmentMetrics } from '../../../hooks/metrics/useFetchActiveInvestmentMetric';
import { useFetchNextInvestmentRepayment } from '../../../hooks/metrics/useFetchNextInvestmentRepayment';
import { NextRepaymentErrorFallback } from '../../ErrorFallback/NextRepaymentErrorFallback';
import { useFetchTransactionHistory } from '../../../hooks/transactions/useFetchTransactions';

const InvestorDashboard = () => {
  const { auth } = useSelector((state: RootState) => state);
  const firstname = auth.authUser?.user.firstname;

  const {error: historyError, fetching: fetchingHistory, transactionHistory, fetchTransactionHistory} = useFetchTransactionHistory();
  const {error: metricError, fetching: fetchingMetrics, activeInvestmentMetrics, fetchInvestmentMetrics} = useFetchActiveInvestmentMetrics()
  const { error: repaymentError, fetching: fetchingRepayment, nextInvestmentRepayment, fetchNextInvestmentRepayment } = useFetchNextInvestmentRepayment();

  return (
    <Page title={`Hello, ${firstname}`}>
      <div className='row'>
        <div className='col-lg-8'>
          <div className='row'>
            <div className='col-lg-5'>
              <div className='card bg-success hoverable card-xl-stretch mb-5 mb-xl-8' style={{ minHeight: '290px' }}>
                <div className='card-body'>
                  <div className='fw-bold text-inverse-success fs-7 mb-2'>Investment Options For You</div>
                  <h1 className='mt-15 mb-15 text-white fw-700'>
                    <ReactTypingEffect cursor='_' text={['Mortgage', 'Equity Finance', 'Rent', 'Payday']} /> <br /> Loan
                  </h1>
                  <div className='text-end fw-bold text-white mt-15'>
                    <Link to='/loans' className='text-white'>
                      Start Investing <i className='bi bi-arrow-right-circle text-white'></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-lg-7'>
              <ErrorBoundary FallbackComponent={ErrorFallback} onReset={fetchInvestmentMetrics}>
                <InvestmentMetrics error={metricError} fetching={fetchingMetrics} activeInvestmentMetrics={activeInvestmentMetrics} />
              </ErrorBoundary>
            </div>
          </div>
          <ErrorBoundary FallbackComponent={ErrorFallback} onReset={fetchTransactionHistory}>
            <RecentTransactions transactionHistory={transactionHistory} fetching={fetchingHistory} error={historyError} />
          </ErrorBoundary>
        </div>
        <div className='col-lg-4'>
          <ErrorBoundary FallbackComponent={NextRepaymentErrorFallback} onReset={fetchNextInvestmentRepayment}>
            <NextInvestmentRepayment error={repaymentError} fetching={fetchingRepayment} nextInvestmentRepayment={nextInvestmentRepayment} />
          </ErrorBoundary>
          <LoanCalculator />
        </div>
      </div>
    </Page>
  );
};

export default InvestorDashboard;
